import React, { useEffect, useState } from 'react';
import { Box } from '@mui/joy';
import ButtonAttribute from '../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash, faGasPump } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../Components/TableData';
import { Divider, Grid, ThemeProvider, Typography, createTheme } from '@mui/material';
import BasicModal from '../Components/BasicModel';
import axios from 'axios';
import { API } from '../API/api';
import TextInputMui from '../Components/TextInputMui';
import AlertBar from '../Components/AlertBar';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../Components/CustomizedProgressBars';
import AutocompleteComboBox from '../Components/AutocompleteComboBox';
import DateTimePickerComponent from '../Components/DateTimePicker';
import { logOperation } from '../API/logOperation';
import dayjs from 'dayjs';
import { toast } from "react-toastify";



const theme = createTheme({
    typography: { fontFamily: 'Montserrat, sans-serif' },
    palette: { mode: 'light', primary: { main: '#1976d2' } },
});

export default function Carburant() {
    const [isLoading, setIsLoading] = useState(0);
    const [Carburant, setCarburant] = useState([]);
    const [vehicules, setVehicules] = useState([]);
    const [chauffeurs, setChauffeurs] = useState([]);

    const [lastKilometrage, setLastKilometrage] = useState(null);
    const handleVehiculeChange = (id) => {
        setNewCarburant((p) => ({ ...p, VéhiculeID: id }));

        // EXAMPLE: fetch last mileage of this vehicle
        const vehicule = vehicules.find(v => v.id === id);
        setLastKilometrage(vehicule?.lastKilometrage || null);
    };

    const handleModifierVehiculeChange = (id) => {
        setModifierCarburant((p) => ({ ...p, VéhiculeID: id }));

        // EXAMPLE: fetch last mileage of this vehicle
        const vehicule = vehicules.find(v => v.id === id);
        setLastKilometrage(vehicule?.lastKilometrage || null);
    };


    const [openAjouterCarburant, setOpenAjouterCarburant] = useState(false);
    const [openModifierCarburant, setOpenModifierCarburant] = useState(false);
    const [openDeleteCarburant, setOpenDeleteCarburant] = useState(false);
    const [openExtrationCarburant, setOpenExtrationCarburant] = useState(false);
    const [openImportationCarburant, setOpenImportationCarburant] = useState(false);
    const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);

    const [rowsSelected, setRowsSelected] = useState([]);
    const [Permissions, setPermissions] = useState([]);
    const [role, setRole] = useState('');

    const [errors, setErrors] = useState({ error: false, message: '' });
    const [errorsModifier, setErrorsModifier] = useState({ error: false, message: '' });

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
    const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
    const [alertOpenUpdatedCarburant, setAlertOpenUpdatedCarburant] = useState(false);
    const [alertOpenDeletedCarburant, setAlertOpenDeletedCarburant] = useState(false);
    const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
    const [alertOpenMultiDeletedCarburant, setAlertOpenMultiDeletedCarburant] = useState(false);
    const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
    const [alertOpenImport, setAlertOpenImport] = useState(false);
    const [alertErrorImport, setAlertErrorImport] = useState(false);
    const [alertOpenConfirmDeleteCarburant, setAlertOpenConfirmDeleteCarburant] = useState(false);

    const [ConfrimedPassword, setConfirmedPassword] = useState({ password: '', errors: '' });

    const [newCarburant, setNewCarburant] = useState({
        VéhiculeID: '',
        ChauffeurID: '',
        Station: '',
        Quantité: '',
        Coût: '',
        Date: dayjs(new Date()).format('YYYY-MM-DD'),
        Kilometrage: '',
        Consommation: '',
        CarteCarburantNumero: '',
        CartePlafond: '',
        CarteExpiration: '',
    });
    useEffect(() => {
        const qte = Number(newCarburant.Quantité);
        const kmNow = Number(newCarburant.Kilometrage);
        const kmBefore = Number(lastKilometrage);

        if (qte > 0 && kmNow > kmBefore) {
            const distance = kmNow - kmBefore;
            const consommation = ((qte / distance) * 100).toFixed(2);

            setNewCarburant((p) => ({
                ...p,
                Consommation: consommation,
            }));
        } else {
            setNewCarburant((p) => ({
                ...p,
                Consommation: "",
            }));
        }
    }, [newCarburant.Quantité, newCarburant.Kilometrage, lastKilometrage]);


    const [modifierCarburant, setModifierCarburant] = useState({
        id: '',
        VéhiculeID: '',
        ChauffeurID: '',
        Station: '',
        Quantité: '',
        Coût: '',
        Date: '',
        Kilometrage: '',
        Consommation: '',
        CarteCarburantNumero: '',
        CartePlafond: '',
        CarteExpiration: '',
    });
    useEffect(() => {
        const qte = Number(modifierCarburant.Quantité);
        const kmNow = Number(modifierCarburant.Kilometrage);
        const kmBefore = Number(lastKilometrage);

        if (qte > 0 && kmNow > kmBefore) {
            const distance = kmNow - kmBefore;
            const consommation = ((qte / distance) * 100).toFixed(2);

            setModifierCarburant((p) => ({
                ...p,
                Consommation: consommation,
            }));
        } else {
            setModifierCarburant((p) => ({
                ...p,
                Consommation: "",
            }));
        }
    }, [modifierCarburant.Quantité, modifierCarburant.Kilometrage, lastKilometrage]);
    const getPermission = (permissions, section, actionName) => {
        const sectionPermissions = permissions.find((perm) => perm.name === section);
        if (!sectionPermissions) return 0;
        const action = sectionPermissions.actions.find((act) => act.name === actionName);
        return action?.allowed ?? 0;
    };

    const isAllowedAjouterCarburant = getPermission(Permissions, 'Carburants', 'ajouter Carburant');
    const isAllowedModifierCarburant = getPermission(Permissions, 'Carburants', 'modifier Carburant');
    const isAllowedSupprimerCarburant = getPermission(Permissions, 'Carburants', 'supprimer Carburant');
    const isAllowedExporterCarburant = getPermission(Permissions, 'Carburants', 'exporter Carburant');
    const isAllowedImporterCarburant = getPermission(Permissions, 'Carburants', 'importer Carburant');

    useEffect(() => {

        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState || '{}');

        localStorage.removeItem('selectedRows');

        if (parsedAuthState?.token) {
            setPermissions(parsedAuthState.permissions || []);
            setRole(parsedAuthState.user?.role?.name || '');
            fetchCarburant(parsedAuthState.token);
            fetchGetVehicules(parsedAuthState.token);
            fetchGetChauffeurs(parsedAuthState.token);
            const intervalId = setInterval(() => {
                setErrors({ error: false, message: '' });
                setErrorsModifier({ error: false, message: '' });
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, []);

    const fetchCarburant = async (token) => {
        try {
            const response = await axios.get(`${API}/carburants`, { headers: { Authorization: `Bearer ${token}` } });
            setCarburant(response.data.data || []);
        } catch (error) {
            setErrors({ error: true, message: 'Failed to fetch Carburant' });
        }
    };

    const fetchGetVehicules = async (token) => {
        try {
            const response = await axios.get(`${API}/vehicules`, { headers: { Authorization: `Bearer ${token}` } });
            setVehicules(response.data.data || []);
        } catch {
            setErrors({ error: true, message: 'Failed to fetch vehicules' });
        }
    };

    const fetchGetChauffeurs = async (token) => {
        try {
            const response = await axios.get(`${API}/chauffeurs`, { headers: { Authorization: `Bearer ${token}` } });
            setChauffeurs(response.data.data || []);
        } catch {
            setErrors({ error: true, message: 'Failed to fetch chauffeurs' });
        }
    };

    const handleOpen = () => setOpenAjouterCarburant(true);
    const handleClose = () => setOpenAjouterCarburant(false);

    const handleOpenModifier = () => {
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows') || '[]');
        if (selectedRows.length > 0) {
            setOpenModifierCarburant(true);
            setRowsSelected(selectedRows);
            const r = selectedRows[0];
            setModifierCarburant({
                id: r.id ?? '',
                VéhiculeID: r.VéhiculeID ?? '',
                ChauffeurID: r.ChauffeurID ?? '',
                Station: r.Station ?? '',
                Quantité: r.Quantité ?? '',
                Coût: r.Coût ?? '',
                Date: r.Date ?? '',
                Kilometrage: r.Kilometrage ?? '',
                Consommation: r.Consommation ?? '',
                CarteCarburantNumero: r.CarteCarburantNumero ?? '',
                CartePlafond: r.CartePlafond ?? '',
                CarteExpiration: r.CarteExpiration ?? '',
            });
        } else {
            setAlertOpenSelectedModifier(true);
        }
    };
    const handleCloseModifier = () => setOpenModifierCarburant(false);

    const handleOpenDeleteCarburant = () => {
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows') || '[]');
        if (selectedRows.length > 0) {
            setOpenDeleteCarburant(true);
            setRowsSelected(selectedRows);
        } else {
            setAlertOpenSelectedModifier(true);
        }
    };
    const handleCloseDeleteCarburant = () => setOpenDeleteCarburant(false);

    const handleOpenExtrationCarburant = () => setOpenExtrationCarburant(true);
    const handleCloseExtrationCarburant = () => setOpenExtrationCarburant(false);

    const handleOpenImportationCarburant = () => setOpenImportationCarburant(true);
    const handleCloseImportationCarburant = () => setOpenImportationCarburant(false);

    const handleOpenConfirmationPassword = () => setOpenConfirmationPassword(true);
    const handleCloseConfirmationPassword = () => setOpenConfirmationPassword(false);

    // helpers
    const fmtDate = v => v ? new Date(v).toLocaleDateString('fr-FR') : '';
    const fmtDT = v => v ? new Date(v).toLocaleString('fr-FR') : '';
    const fmtNum = v => v == null ? '' : Number(v).toLocaleString('fr-FR');
    const fmtDh = v => v == null ? '' : `${Number(v).toLocaleString('fr-FR')} DH`;
    const seuilConso = 40; // L/100km

    // columns (suppose que `vehicules` et `chauffeurs` sont en portée)
    const columns = [
        { accessorKey: 'id', header: 'ID', size: 90 },

        {
            accessorKey: 'VéhiculeID',
            header: 'Véhicule',
            size: 170,
            Cell: ({ cell }) => {
                const id = cell.getValue();
                const v = vehicules?.find(x => String(x.id) === String(id));
                // affiche matricule ou code_vehicule si dispo
                return v ? (v.matricule || v.code_vehicule || `#${id}`) : `#${id}`;
            }
        },
        {
            accessorKey: 'ChauffeurID',
            header: 'Chauffeur',
            size: 200,
            Cell: ({ cell }) => {
                const id = cell.getValue();
                const c = chauffeurs?.find(x => String(x.id) === String(id));
                return c ? `${c.Nom} ${c.Prénom}` : `#${id}`;
            }
        },

        { accessorKey: 'Station', header: 'Station', size: 160 },

        {
            accessorKey: 'Quantité',
            header: 'Quantité (L)',
            size: 140,
            Cell: ({ cell }) => fmtNum(cell.getValue()),
        },
        {
            accessorKey: 'Coût',
            header: 'Coût (DH)',
            size: 140,
            Cell: ({ cell }) => fmtDh(cell.getValue()),
        },
        {
            accessorKey: 'Date',
            header: 'Date',
            size: 140,
            Cell: ({ cell }) => fmtDate(cell.getValue()),
        },
        {
            accessorKey: 'Kilometrage',
            header: 'Kilométrage',
            size: 140,
            Cell: ({ cell }) => fmtNum(cell.getValue()),
        },
        {
            accessorKey: 'Consommation',
            header: 'Conso (L/100km)',
            size: 160,
            Cell: ({ cell }) => {
                const v = Number(cell.getValue());
                if (!Number.isFinite(v)) return '';
                const text = `${v.toLocaleString('fr-FR')} L/100`;
                return (
                    <span style={{ color: v >= seuilConso ? '#c62828' : undefined, fontWeight: v >= seuilConso ? 600 : 400 }}>
                        {text}
                    </span>
                );
            },
        },

        { accessorKey: 'CarteCarburantNumero', header: 'Carte N°', size: 160 },
        {
            accessorKey: 'CartePlafond',
            header: 'Plafond (DH)',
            size: 150,
            Cell: ({ cell }) => fmtDh(cell.getValue()),
        },
        {
            accessorKey: 'CarteExpiration',
            header: 'Expiration carte',
            size: 160,
            Cell: ({ cell }) => fmtDate(cell.getValue()),
        },

        {
            accessorKey: 'created_at',
            header: 'Créé le',
            size: 170,
            Cell: ({ cell }) => fmtDT(cell.getValue()),
        },
        {
            accessorKey: 'updated_at',
            header: 'MAJ',
            size: 170,
            Cell: ({ cell }) => fmtDT(cell.getValue()),
        },
    ];

    // === Ajout Carburant ===
    const handleAjouterCarburant = () => {
        const stored = sessionStorage.getItem('authLocalstorage');
        const { token, user } = JSON.parse(stored || '{}');

        const requiredFields = {
            VéhiculeID: "Véhicule",
            ChauffeurID: "Chauffeur",
            Quantité: "Quantité",
            Coût: "Coût",
        };

        const missing = Object.entries(requiredFields)
            .filter(([key]) => {
                const value = newCarburant[key];
                return (
                    value === null ||
                    value === undefined ||
                    value === "" ||
                    (typeof value === "string" && value.trim() === "")
                );
            })
            .map(([, label]) => label);

        if (missing.length > 0) {
            setErrors({
                error: true,
                message: `Champs obligatoires manquants : ${missing.join(", ")}`,
            });
            return;
        }

        const num = (v, def = 0) => (v === '' || v === null || v === undefined ? def : Number(v));
        const dateOnly = (v) => (v ? dayjs(v).format('YYYY-MM-DD') : null);
        const str = (v) => (v && String(v).trim() ? String(v).trim() : null);

        const payload = {
            VéhiculeID: Number(newCarburant.VéhiculeID),
            ChauffeurID: Number(newCarburant.ChauffeurID),
            Station: str(newCarburant.Station),
            Quantité: num(newCarburant.Quantité),
            Coût: num(newCarburant.Coût),
            Date: dateOnly(newCarburant.Date),
            Kilometrage: num(newCarburant.Kilometrage),
            Consommation: newCarburant.Consommation, // jamais NULL
            CarteCarburantNumero: str(newCarburant.CarteCarburantNumero),
            CartePlafond: num(newCarburant.CartePlafond, 0),
            CarteExpiration: dateOnly(newCarburant.CarteExpiration),
        };

        if (
            Number(newCarburant.Kilometrage) <= Number(lastKilometrage)
        ) {
            setErrors({
                error: true,
                message: "Le kilométrage doit être supérieur au dernier relevé",
            });
            return;
        }

        axios
            .post(`${API}/carburants`, payload, { headers: { Authorization: `Bearer ${token}` } })
            .then(() => {
                handleClose();
                setAlertOpen(true);
                fetchCarburant(token);

                setNewCarburant({
                    VéhiculeID: '',
                    ChauffeurID: '',
                    Station: '',
                    Quantité: '',
                    Coût: '',
                    Date: '',
                    Kilometrage: '',
                    Consommation: '',
                    CarteCarburantNumero: '',
                    CartePlafond: '',
                    CarteExpiration: '',
                });

                logOperation({
                    operation_type: 'Ajout',
                    entity_type: 'Carburant',
                    entity_id: user?.id,
                    description: 'Ajout Carburant',
                });
            })
            .catch((error) => {
                setErrors({
                    error: true,
                    message: error?.response?.data?.message || 'Erreur serveur',
                });
            });
    };



    const handleOpenModifierOneCarburant = async () => {
        const stored = sessionStorage.getItem('authLocalstorage');
        const { token, user } = JSON.parse(stored || '{}');
        const original = rowsSelected?.[0];

        if (!token || !original) {
            setErrorsModifier({ error: true, message: 'Session ou ligne invalide.' });
            return;
        }

        const iso = (v) => (v ? dayjs(v).isValid() ? dayjs(v).format('YYYY-MM-DD') : null : null);
        const num = (v) => {
            const n = Number(v);
            return Number.isFinite(n) ? n : null;
        };
        const int = (v) => {
            const n = parseInt(v, 10);
            return Number.isFinite(n) ? n : null;
        };
        const str = (v) => {
            const s = (v ?? '').toString().trim();
            return s || null;
        };

        // unchanged check with normalized values
        const same =
            Number(original.VéhiculeID) === Number(modifierCarburant.VéhiculeID) &&
            str(original.ChauffeurID) === str(modifierCarburant.ChauffeurID) &&
            str(original.Station) === str(modifierCarburant.Station) &&
            num(original.Quantité) === num(modifierCarburant.Quantité) &&
            num(original.Coût) === num(modifierCarburant.Coût) &&
            iso(original.Date) === iso(modifierCarburant.Date) &&
            int(original.Kilometrage) === int(modifierCarburant.Kilometrage) &&
            str(original.CarteCarburantNumero) === str(modifierCarburant.CarteCarburantNumero) &&
            num(original.CartePlafond) === num(modifierCarburant.CartePlafond) &&
            iso(original.CarteExpiration) === iso(modifierCarburant.CarteExpiration) &&
            num(original.Consommation ?? 0) === (num(modifierCarburant.Consommation) ?? 0);

        if (same) { setAlertOpenNotModiferRow(true); return; }

        // required fields (align with backend)
        const required = {
            VéhiculeID: modifierCarburant.VéhiculeID,
            Quantité: modifierCarburant.Quantité,
            Coût: modifierCarburant.Coût,
            Date: modifierCarburant.Date,
            Kilometrage: modifierCarburant.Kilometrage,
        };
        const missing = Object.entries(required).filter(([, v]) => v === '' || v === null || v === undefined);
        if (missing.length) {
            setErrorsModifier({ error: true, message: 'Champs obligatoires manquants.' });
            return;
        }

        const ID = original.id;

        const payload = {
            VéhiculeID: Number(modifierCarburant.VéhiculeID),
            ChauffeurID: modifierCarburant.ChauffeurID ? Number(modifierCarburant.ChauffeurID) : null,
            Station: str(modifierCarburant.Station),
            Quantité: num(modifierCarburant.Quantité),
            Coût: num(modifierCarburant.Coût),
            Date: iso(modifierCarburant.Date),                         // "YYYY-MM-DD"
            Kilometrage: int(modifierCarburant.Kilometrage),
            Consommation: (num(modifierCarburant.Consommation) ?? 0),  // NOT NULL en DB
            CarteCarburantNumero: str(modifierCarburant.CarteCarburantNumero),
            CartePlafond: num(modifierCarburant.CartePlafond),
            CarteExpiration: iso(modifierCarburant.CarteExpiration),
        };

        // guard against illegal values
        if ([payload.Quantité, payload.Coût, payload.Kilometrage].some((v) => v === null)
            || !payload.Date) {
            setErrorsModifier({ error: true, message: 'Types invalides. Vérifiez nombres et dates.' });
            return;
        }

        try {
            await axios.put(`${API}/carburants/${ID}`, payload, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAlertOpenUpdatedCarburant(true);
            handleCloseModifier();
            fetchCarburant(token);
            logOperation({
                operation_type: 'Update',
                entity_type: 'Carburant',
                entity_id: user?.id,
                description: `Update Carburant ID ${ID}`,
            });
        } catch (error) {
            setErrorsModifier({
                error: true,
                message: error?.response?.data?.message || 'Erreur serveur',
            });
        }
    };


    const handleDeleteCarburant = async () => {
        const stored = sessionStorage.getItem('authLocalstorage');
        const { token, user } = JSON.parse(stored || '{}');
        const ID = rowsSelected[0].id;

        try {
            await axios.delete(`${API}/carburants/${ID}`, { headers: { Authorization: `Bearer ${token}` } });
            handleCloseDeleteCarburant();
            setAlertOpenDeletedCarburant(true);
            fetchCarburant(token);
            logOperation({ operation_type: 'Delete', entity_type: 'Carburant', entity_id: user?.id, description: 'Delete Carburant' });
        } catch (error) {
            setErrors({ error: true, message: error?.response?.data?.message || 'Erreur serveur' });
        }
    };

    const handleDeleteMultiCarburant = async () => {
        const stored = sessionStorage.getItem('authLocalstorage');
        const { token, user } = JSON.parse(stored || '{}');

        try {
            await Promise.all(
                rowsSelected.map((row) => axios.delete(`${API}/carburants/${row.id}`, { headers: { Authorization: `Bearer ${token}` } }))
            );
            handleCloseDeleteCarburant();
            setAlertOpenMultiDeletedCarburant(true);
            fetchCarburant(token);
            logOperation({ operation_type: 'Delete Multiple', entity_type: 'Carburant', entity_id: user?.id, description: 'Delete Multiple Carburant' });
        } catch (error) {
            setErrors({ error: true, message: error?.response?.data?.message || 'Erreur serveur' });
        }
    };

    const handleVerificationPassword = () => {
        const stored = sessionStorage.getItem('authLocalstorage');
        const parsed = JSON.parse(stored || '{}');
        const email = parsed?.user?.email;
        const password = ConfrimedPassword.password;

        axios.post(`${API}/verify-password`, { email, password })
            .then((response) => {
                if (response.data.success) {
                    if (rowsSelected.length === 1) handleDeleteCarburant();
                    else handleDeleteMultiCarburant();
                    handleCloseConfirmationPassword();
                } else {
                    setConfirmedPassword({ errors: true, password: '' });
                    setAlertOpenPasswordNotValid(true);
                }
            })
            .catch(() => {
                setConfirmedPassword({ errors: true, password: '' });
                setAlertOpenPasswordNotValid(true);
            });
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `/ImportCarburant.xlsx`;
        link.download = 'ImportCarburant.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const triggerFileInput = () => document.getElementById('file-upload').click();

   const handleFileImport = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const stored = sessionStorage.getItem("authLocalstorage");
    const { token, user } = JSON.parse(stored || "{}");

    if (!token) {
        toast.error("Session invalide. Veuillez vous reconnecter.");
        return;
    }

    const str = (v) => {
        const s = (v ?? "").toString().trim();
        return s || null;
    };

    const num = (v) => {
        if (v === null || v === undefined || v === "") return null;
        const n = Number(String(v).replace(",", "."));
        return Number.isFinite(n) ? n : null;
    };

    const int = (v) => {
        if (v === null || v === undefined || v === "") return null;
        const n = parseInt(String(v).trim(), 10);
        return Number.isFinite(n) ? n : null;
    };

    const isoDate = (v) => {
        if (!v && v !== 0) return null;

        if (v instanceof Date && !isNaN(v))
            return v.toISOString().slice(0, 10);

        if (typeof v === "number") {
            const ms = Math.round((v - 25569) * 86400 * 1000);
            const d = new Date(ms);
            return isNaN(d) ? null : d.toISOString().slice(0, 10);
        }

        const d = dayjs(v);
        return d.isValid() ? d.format("YYYY-MM-DD") : null;
    };

    const reader = new FileReader();

    reader.onload = async (e) => {
        try {
            const wb = XLSX.read(e.target.result, {
                type: "binary",
                cellDates: true,
            });

            const sheet = wb.Sheets[wb.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: null });

            if (!rows.length) {
                toast.warning("Le fichier est vide.");
                return;
            }

            const total = rows.length;
            let done = 0;
            let success = 0;
            let failed = 0;
            const errorLines = [];

            setIsLoading(0);

            for (let i = 0; i < rows.length; i++) {
                const r = rows[i];

                const payload = {
                    VéhiculeID: int(r["VéhiculeID"]),
                    ChauffeurID: int(r["ChauffeurID"]),
                    Station: str(r["Station"]),
                    Quantité: num(r["Quantité"]),
                    Coût: num(r["Coût"]),
                    Date: isoDate(r["Date"]),
                    Kilometrage: int(r["Kilometrage"]),
                    Consommation: num(r["Consommation"]) ?? 0,
                    CarteCarburantNumero: str(r["CarteCarburantNumero"]),
                    CartePlafond: num(r["CartePlafond"]),
                    CarteExpiration: isoDate(r["CarteExpiration"]),
                };

                const missing = [];

                if (payload.VéhiculeID === null) missing.push("VéhiculeID");
                if (payload.Quantité === null) missing.push("Quantité");
                if (payload.Coût === null) missing.push("Coût");
                if (!payload.Date) missing.push("Date");
                if (payload.Kilometrage === null) missing.push("Kilometrage");

                if (missing.length > 0) {
                    failed++;
                    errorLines.push(
                        `Ligne ${i + 2}: ${missing.join(", ")}`
                    );
                } else {
                    try {
                        await axios.post(`${API}/carburants`, payload, {
                            headers: { Authorization: `Bearer ${token}` },
                        });
                        success++;
                    } catch (err) {
                        failed++;
                        errorLines.push(
                            `Ligne ${i + 2}: ${
                                err?.response?.data?.message || "Erreur serveur"
                            }`
                        );
                    }
                }

                done++;
                setIsLoading(Math.round((done / total) * 100));
            }

            setIsLoading(100);

            // ===== RESULT TOASTS =====

            if (success > 0) {
                toast.success(
                    `Import terminé ✔ ${success} ligne(s) insérée(s)`
                );
            }

            if (failed > 0) {
                toast.error(
                    `⚠ ${failed} ligne(s) non insérée(s)`
                );

                // Show detailed error lines
                toast.info(
                    errorLines.slice(0, 5).join(" \n ") +
                        (errorLines.length > 5
                            ? "\n... autres erreurs"
                            : ""),
                    { autoClose: 8000 }
                );
            }

            if (success > 0) {
                fetchCarburant(token);

                logOperation({
                    operation_type: "AJOUTER",
                    entity_type: "Carburant",
                    entity_id: user?.id,
                    description: `Import Carburant - ${success} lignes`,
                });
            }

            setTimeout(() => {
                setIsLoading(0);
            }, 800);
        } catch (error) {
            toast.error("Erreur lors de la lecture du fichier.");
            setIsLoading(0);
        }
    };

    reader.readAsBinaryString(file);
};

const handleExtrationSelectionsCarburant = () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    if (!selectedRows.length) {
        setAlertOpenNotSelectedLineExtration(true);
        return;
    }

    const headers = columns.map((c) => c.header);
    const accessors = columns.map((c) => c.accessorKey);

    const data = selectedRows.map((row) => {
        const obj = {};
        accessors.forEach((key, index) => {
            obj[headers[index]] = row[key] ?? "";
        });
        return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Carburant_Selection");

    XLSX.writeFile(workbook, "Carburant_Selection.xlsx");
};

   const handleExtrationAllCarburant = () => {
    if (!Carburant || Carburant.length === 0) return;

    // Prepare headers
    const headers = columns.map((c) => c.header);
    const accessors = columns.map((c) => c.accessorKey);

    // Prepare data
    const data = Carburant.map((row) => {
        const obj = {};
        accessors.forEach((key, index) => {
            obj[headers[index]] = row[key] ?? "";
        });
        return obj;
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Carburant");

    // Export file
    XLSX.writeFile(workbook, "Carburant.xlsx");
};

    const MenuButton = () => (
        <Box sx={{
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb4b',
            borderRadius: '32px',
            padding: { xs: '20px', md: '30px' },
            marginBottom: '20px',
            boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
        }}>
            {/* Header Section */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '16px',
                borderBottom: '1px solid #f3f4f6'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Box sx={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        backgroundColor: '#3b82f6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <FontAwesomeIcon icon={faGasPump} style={{ color: 'white', fontSize: '16px' }} />
                    </Box>
                    <Typography variant="h4" sx={{
                        fontWeight: 600,
                        color: '#1f2937',
                        fontSize: { xs: '1.25rem', md: '1.5rem' },
                        letterSpacing: '-0.025em'
                    }}>
                        Gestion des Carburants
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{
                    color: '#6b7280',
                    fontSize: '14px',
                    fontWeight: 500,
                    backgroundColor: '#f9fafb',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    border: '1px solid #e5e7eb'
                }}>
                    {Carburant.length} Carburant{Carburant.length !== 1 ? 's' : ''}
                </Typography>
            </Box>

            {/* Action Buttons Section */}
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                marginTop: '30px',
                alignItems: 'center',
                justifyContent: { xs: 'center', md: 'space-between' }
            }}>
                {/* Primary Actions */}
                <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    {isAllowedAjouterCarburant == 1 && (
                        <ButtonAttribute
                            Label="Ajouter"
                            action={handleOpen}
                            Bgcolor="#3b82f6"
                            color="white"
                            bgColorHover="#2563eb"
                            type="button"
                            height="45px"
                            width="150px"
                            startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
                            hidden

                        />
                    )}
                    {isAllowedModifierCarburant == 1 && (
                        <ButtonAttribute
                            Label="Modifier"
                            action={handleOpenModifier}
                            Bgcolor="#f59e0b"
                            color="white"
                            bgColorHover="#d97706"
                            type="button"
                            height="45px"
                            width="150px"
                            startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
                            hidden

                        />
                    )}
                    {isAllowedSupprimerCarburant == 1 && (
                        <ButtonAttribute
                            Label="Supprimer"
                            action={handleOpenDeleteCarburant}
                            Bgcolor="#ef4444"
                            color="white"
                            bgColorHover="#dc2626"
                            type="button"
                            height="45px"
                            width="150px"
                            startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
                            hidden

                        />
                    )}
                </Box>

                {/* Secondary Actions */}
                <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    {isAllowedExporterCarburant == 1 && (
                        <ButtonAttribute
                            Label="Exporter"
                            action={handleOpenExtrationCarburant}
                            Bgcolor="#06b6d4"
                            color="white"
                            bgColorHover="#0891b2"
                            type="button"
                            height="45px"
                            width="150px"
                            startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
                            hidden

                        />
                    )}
                    {isAllowedImporterCarburant == 1 && (
                        <ButtonAttribute
                            Label="Importer"
                            action={handleOpenImportationCarburant}
                            Bgcolor="#8b5cf6"
                            color="white"
                            bgColorHover="#7c3aed"
                            type="button"
                            height="45px"
                            width="150px"
                            startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
                            hidden

                        />
                    )}
                </Box>
            </Box>
        </Box>
    );

    return (
        <ThemeProvider theme={theme}>
            {(role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture') && (
                <Box
                    sx={{
                        flexGrow: 1,
                        backgroundColor: '#f8fafc',
                        padding: { xs: '16px', md: '20px' },
                        minHeight: '116vh',
                        transition: 'all 0.3s ease-in-out',
                    }}
                >
                    <MenuButton />
                    <Box sx={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e5e7eb',
                        overflow: 'hidden'
                    }}>
                        <DataGridTable data={Carburant} columns={columns} />
                    </Box>
                </Box>
            )}

            {/* Ajouter */}
            {/* === Modal Ajout Carburant === */}
            <BasicModal
                widthSpecial="40%"
                open={openAjouterCarburant}
                onClose={handleClose}
                ChildrenContent={
                    <Box>
                        <Box sx={{
                            backgroundColor: '#3b82f6',
                            borderRadius: '23px',
                            padding: '20px',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: { lg: '24px', md: '20px', sm: '18px', xs: '16px' },
                                    fontFamily: 'Montserrat, sans-serif',
                                    color: 'white',
                                    fontWeight: 600,
                                    letterSpacing: '-0.025em'
                                }}
                            >
                                Nouveau Carburant
                            </Typography>
                        </Box>

                        <Grid container spacing={1}>
                            {/* Véhicule */}
                            <Grid item xs={12}>
                                <AutocompleteComboBox
                                    required
                                    widthSpecific="100%"
                                    Label="Véhicule"
                                    list={vehicules}
                                    keyField="id"
                                    valueField="matricule"
                                    dueShowValue
                                    onChange={handleVehiculeChange}
                                    value={newCarburant.VéhiculeID}
                                />

                            </Grid>

                            {/* Chauffeur */}
                            <Grid item xs={12}>
                                <AutocompleteComboBox
                                    required
                                    widthSpecific="100%"
                                    Label="Chauffeur"
                                    list={chauffeurs}
                                    keyField="id"
                                    valueField="Nom"
                                    DeméValue="Prénom"
                                    DueValue
                                    dueShowValue
                                    onChange={(id) => setNewCarburant((p) => ({ ...p, ChauffeurID: id }))}
                                    value={newCarburant.ChauffeurID}
                                />
                            </Grid>

                            {/* Station */}
                            <Grid item xs={12}>
                                <TextInputMui
                                    label="Station / Service"
                                    value={newCarburant.Station}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, Station: v }))}
                                />
                            </Grid>

                            {/* Quantité / Coût */}
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    required
                                    label="Quantité (L)"
                                    type="number"
                                    value={newCarburant.Quantité}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, Quantité: v }))}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    required
                                    label="Coût (DH)"
                                    type="number"
                                    value={newCarburant.Coût}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, Coût: v }))}
                                />
                            </Grid>

                            {/* Date / Kilométrage */}
                            <Grid item xs={12} sm={6}>
                                <DateTimePickerComponent
                                    required
                                    typeDate="date"
                                    label="Date"
                                    dateSelected={(d) =>
                                        setNewCarburant((p) => ({ ...p, Date: dayjs(d).format('YYYY-MM-DD') }))
                                    }
                                    value={newCarburant.Date || ''}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    required
                                    label="Kilométrage compteur"
                                    type="number"
                                    value={newCarburant.Kilometrage}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, Kilometrage: v }))}
                                />
                            </Grid>

                            {/* Carte carburant */}
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    label="N° Carte carburant"
                                    value={newCarburant.CarteCarburantNumero}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, CarteCarburantNumero: v }))}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    label="Plafond carte (DH)"
                                    type="number"
                                    value={newCarburant.CartePlafond}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, CartePlafond: v }))}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DateTimePickerComponent
                                    typeDate="date"
                                    label="Date d'expiration carte"
                                    dateSelected={(d) =>
                                        setNewCarburant((p) => ({
                                            ...p,
                                            CarteExpiration: d ? dayjs(d).format('YYYY-MM-DD') : null,
                                        }))
                                    }
                                    value={newCarburant.CarteExpiration || ''}
                                />
                            </Grid>

                            {/* Consommation */}
                            <Grid item xs={12} sm={6}>
                                <TextInputMui
                                    required
                                    label="Consommation (L/100km)"
                                    type="number"
                                    value={newCarburant.Consommation}
                                    setValue={(v) => setNewCarburant((p) => ({ ...p, Consommation: v }))}
                                />
                            </Grid>

                            {/* Erreurs */}
                            <Grid item xs={12}>
                                {errors.error && (
                                    <Typography variant="subtitle1" component="p" sx={{ color: 'red', textAlign: 'center' }}>
                                        {errors.message}
                                    </Typography>
                                )}
                            </Grid>

                            {/* Action */}
                            <Grid item xs={12}>
                                <Box sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',

                                }}>
                                    <ButtonAttribute
                                        type="submit"
                                        Label="Ajouter"
                                        color="white"
                                        Bgcolor="#3b82f6"
                                        height="44px"
                                        width="180px"
                                        action={handleAjouterCarburant}
                                        sx={{
                                            borderRadius: '6px',
                                            fontWeight: 500,
                                            fontSize: '15px',
                                            textTransform: 'none',
                                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                }
            />


            {/* Modifier */}
            <BasicModal
                widthSpecial={'40%'}
                open={openModifierCarburant}
                onClose={handleCloseModifier}
                ChildrenContent={
                    rowsSelected.length === 1 ? (
                        <Box sx={{ maxHeight: '70vh', overflow: 'auto' }} >
                            <Box sx={{
                                backgroundColor: '#f59e0b',
                                borderRadius: '6px',
                                padding: '20px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontSize: { lg: '24px', md: '20px', sm: '18px', xs: '16px' },
                                        fontFamily: 'Montserrat, sans-serif',
                                        color: 'white',
                                        fontWeight: 600,
                                        letterSpacing: '-0.025em'
                                    }}
                                >
                                    Modifier Carburant ID : {rowsSelected[0].id}
                                </Typography>
                            </Box>

                            <Grid container spacing={2} sx={{ p: '20px', borderRadius: '12px', color: '#1D3E62' }}>
                                {/* Véhicule */}
                                <Grid item xs={12}>
                                    <AutocompleteComboBox
                                        widthSpecific="100%"
                                        Label="Véhicule"
                                        list={vehicules}
                                        keyField="id"
                                        valueField="matricule"
                                        dueShowValue
                                        value={Number(modifierCarburant.VéhiculeID) || ''}
                                        onChange={handleModifierVehiculeChange}
                                    />
                                </Grid>

                                {/* Chauffeur */}
                                <Grid item xs={12}>
                                    <AutocompleteComboBox
                                        widthSpecific="100%"
                                        Label="Chauffeur"
                                        list={chauffeurs}
                                        keyField="id"
                                        valueField="Nom"
                                        DeméValue="Prénom"
                                        DueValue
                                        dueShowValue
                                        value={Number(modifierCarburant.ChauffeurID) || ''}
                                        onChange={(key) =>
                                            setModifierCarburant((prev) => ({ ...prev, ChauffeurID: Number(key) || '' }))
                                        }
                                    />
                                </Grid>

                                {/* Station */}
                                <Grid item xs={12}>
                                    <TextInputMui
                                        label="Station / Service"
                                        value={modifierCarburant.Station ?? ''}
                                        setValue={(v) => setModifierCarburant((p) => ({ ...p, Station: v }))}
                                    />
                                </Grid>

                                {/* Quantité / Coût */}
                                <Grid item xs={12} sm={6}>
                                    <TextInputMui
                                        label="Quantité (en L)"
                                        type="number"
                                        value={modifierCarburant.Quantité ?? ''}
                                        setValue={(v) =>
                                            setModifierCarburant((p) => ({ ...p, Quantité: v === '' ? '' : Number(v) }))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextInputMui
                                        label="Coût (en DH)"
                                        type="number"
                                        value={modifierCarburant.Coût ?? ''}
                                        setValue={(v) =>
                                            setModifierCarburant((p) => ({ ...p, Coût: v === '' ? '' : Number(v) }))
                                        }
                                    />
                                </Grid>

                                {/* Date achat */}
                                <Grid item xs={12}>
                                    <DateTimePickerComponent
                                        widthSpecific="100%"
                                        typeDate="date"
                                        label="Date d'achat"
                                        value={dayjs(modifierCarburant.Date).format('YYYY-MM-DD') || modifierCarburant.Date || null}                 // objet Date/ISO
                                        dateSelected={(val) => setModifierCarburant((p) => ({ ...p, Date: val }))}
                                    />
                                </Grid>

                                {/* Kilométrage */}
                                <Grid item xs={12} sm={6}>
                                    <TextInputMui
                                        label="Kilométrage compteur"
                                        type="number"
                                        value={modifierCarburant.Kilometrage ?? ''}
                                        setValue={(v) =>
                                            setModifierCarburant((p) => ({ ...p, Kilometrage: v === '' ? '' : Number(v) }))
                                        }
                                    />
                                </Grid>

                                {/* Carte carburant */}
                                <Grid item xs={12} sm={6}>
                                    <TextInputMui
                                        label="N° Carte carburant"
                                        value={modifierCarburant.CarteCarburantNumero ?? ''}
                                        setValue={(v) => setModifierCarburant((p) => ({ ...p, CarteCarburantNumero: v }))}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextInputMui
                                        label="Plafond carte (DH)"
                                        type="number"
                                        value={modifierCarburant.CartePlafond ?? ''}
                                        setValue={(v) =>
                                            setModifierCarburant((p) => ({ ...p, CartePlafond: v === '' ? '' : Number(v) }))
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <DateTimePickerComponent
                                        typeDate="date"
                                        label="Date d'expiration carte"
                                        value={dayjs(modifierCarburant.CarteExpiration).format('YYYY-MM-DD')}
                                        dateSelected={(val) => setModifierCarburant((p) => ({ ...p, CarteExpiration: val }))}
                                    />
                                </Grid>

                                {/* Consommation */}
                                <Grid item xs={12}>
                                    <TextInputMui
                                        label="Consommation (L/100km)"
                                        type="number"
                                        value={modifierCarburant.Consommation ?? 0} // DB NOT NULL → garder un nombre
                                        setValue={(v) =>
                                            setModifierCarburant((p) => ({
                                                ...p,
                                                Consommation: v === '' ? 0 : Number(v),
                                            }))
                                        }
                                    />
                                </Grid>

                                {/* Erreurs */}
                                {errorsModifier?.error && (
                                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Typography variant="body2" sx={{ color: 'red' }}>
                                            {errorsModifier.message}
                                        </Typography>
                                    </Grid>
                                )}

                                {/* Bouton */}
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box
                                        sx={{
                                            width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '100%' },
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <ButtonAttribute
                                            type="submit"
                                            Label="Modifier Carburant"
                                            color="white"
                                            Bgcolor="#f59e0b"
                                            height="44px"
                                            width="100%"
                                            action={handleOpenModifierOneCarburant}
                                            sx={{
                                                borderRadius: '6px',
                                                fontWeight: 500,
                                                fontSize: '15px',
                                                textTransform: 'none',
                                                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                                }
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    ) : (
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: { lg: '20px', md: '20px', sm: '20px', xs: '20px' },
                                mb: 2,
                                fontFamily: 'Montserrat , sans-serif',
                                color: '#1D3E62',
                                textAlign: 'center',
                                fontWeight: 600,
                                p: '20px',
                            }}
                        >
                            L'opération demandée est invalide. Les modifications multiples ne sont pas autorisées.
                        </Typography>
                    )
                }
            />


            {/* Supprimer */}
            <BasicModal
                open={openDeleteCarburant}
                onClose={handleCloseDeleteCarburant}
                ChildrenContent={
                    rowsSelected.length === 1 ? (
                        <Box>
                            <Box sx={{
                                backgroundColor: '#ef4444',
                                borderRadius: '6px',
                                padding: '20px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                <Typography variant="h4" sx={{
                                    fontSize: { lg: '20px', md: '18px', sm: '16px', xs: '14px' },
                                    fontFamily: 'Montserrat, sans-serif',
                                    color: 'white',
                                    fontWeight: 600,
                                    letterSpacing: '-0.025em'
                                }}>
                                    Suppression Carburant ID : {rowsSelected[0].id}
                                </Typography>
                            </Box>

                            <Typography variant="h6" sx={{
                                fontSize: { lg: '16px', md: '14px', sm: '12px', xs: '12px' },
                                mb: 3,
                                fontFamily: 'Montserrat, sans-serif',
                                color: '#374151',
                                textAlign: 'center',
                                fontWeight: 500
                            }}>
                                Voulez-vous vraiment supprimer cette entrée ?
                            </Typography>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '12px',
                                flexWrap: 'wrap'
                            }}>
                                <ButtonAttribute
                                    type="submit"
                                    Label="Annuler"
                                    color="white"
                                    Bgcolor="#6b7280"
                                    height="40px"
                                    width="120px"
                                    action={handleCloseDeleteCarburant}
                                    sx={{
                                        borderRadius: '6px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        textTransform: 'none',
                                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                        }
                                    }}
                                />
                                <ButtonAttribute
                                    type="submit"
                                    Label="Supprimer"
                                    color="white"
                                    Bgcolor="#ef4444"
                                    height="40px"
                                    width="120px"
                                    action={handleOpenConfirmationPassword}
                                    sx={{
                                        borderRadius: '6px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        textTransform: 'none',
                                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    ) : (
                        <Box>
                            <Typography variant="h4" sx={{ fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' }, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', p: '10px' }}>
                                Suppression des Carburants sélectionnées
                            </Typography>

                            {rowsSelected.length > 1 && (
                                <Box sx={{ justifyContent: 'center', display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', mb: '20px' }}>
                                    {rowsSelected.map((row, i) => (
                                        <Box key={i} sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', mb: '20px', p: '10px', width: '50px', height: '40px', borderRadius: '10%', backgroundColor: '#DC3545' }}>
                                            <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
                                                {row.id ?? 'N/A'}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            )}

                            <Box sx={{ display: { xs: 'grid', md: 'flex' }, justifyContent: 'space-evenly', alignItems: 'center', gap: '20px' }}>
                                <ButtonAttribute type="submit" Label="Annuler" color="white" Bgcolor="gray" height="50px" width="100%" action={handleCloseDeleteCarburant} />
                                <ButtonAttribute type="submit" Label="Supprimer toutes" color="white" Bgcolor="#DC3545" height="50px" width="100%" action={handleOpenConfirmationPassword} />
                            </Box>
                        </Box>
                    )
                }
            />

            {/* Export */}
            <BasicModal
                open={openExtrationCarburant}
                onClose={handleCloseExtrationCarburant}
                ChildrenContent={
                    <Box sx={{ px: 3, py: 2 }}>

                        {/* ===== Title ===== */}
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: { lg: 32, md: 26, sm: 22, xs: 18 },
                                fontFamily: "Montserrat, sans-serif",
                                color: "#1D3E62",
                                textAlign: "center",
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Extraction des Données Carburant
                        </Typography>

                        {/* ===== Subtitle ===== */}
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: { md: 15, sm: 14, xs: 13 },
                                color: "#6B7280",
                                textAlign: "center",
                                mb: 3,
                            }}
                        >
                            Sélectionnez le type d'extraction souhaité pour télécharger vos données.
                        </Typography>

                        {/* ===== Extraction Options ===== */}
                        <Box
                            sx={{
                                p: 3,
                                borderRadius: "12px",
                                border: "1px solid #E5E7EB",
                                backgroundColor: "#F9FAFB",
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <ButtonAttribute
                                type="button"
                                Label="Exporter toutes les données (XLSX)"
                                Bgcolor="#2563EB"
                                color="white"
                                bgColorHover="#1D4ED8"
                                height="55px"
                                width="100%"
                                endIcon={
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        color="white"
                                        style={{ fontSize: "14px" }}
                                    />
                                }
                                action={handleExtrationAllCarburant}
                            />

                            <ButtonAttribute
                                type="button"
                                Label="Exporter les lignes sélectionnées (XLSX)"
                                Bgcolor="#10B981"
                                color="white"
                                bgColorHover="#059669"
                                height="55px"
                                width="100%"
                                endIcon={
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        color="white"
                                        style={{ fontSize: "14px" }}
                                    />
                                }
                                action={handleExtrationSelectionsCarburant}
                            />
                        </Box>
                    </Box>
                }
            />

            {/* Import */}
            <BasicModal
                open={openImportationCarburant}
                onClose={handleCloseImportationCarburant}
                ChildrenContent={
                  <Box>
  {/* Header Block */}
  <Box
    sx={{
      background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
      borderRadius: "10px",
      padding: "22px",
      marginBottom: "24px",
      textAlign: "center",
      boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)",
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontSize: { lg: "22px", md: "20px", sm: "18px", xs: "16px" },
        fontFamily: "Montserrat, sans-serif",
        color: "white",
        fontWeight: 700,
        letterSpacing: "-0.02em",
      }}
    >
      Importation des Données Excel
    </Typography>

    <Typography
      sx={{
        fontSize: "13px",
        color: "rgba(255,255,255,0.85)",
        marginTop: "6px",
        fontWeight: 400,
      }}
    >
      Téléchargez le modèle officiel puis importez votre fichier complété.
    </Typography>
  </Box>

  {/* Download Section */}
  <Typography
    sx={{
      fontSize: "13px",
      mb: 2,
      fontFamily: "Montserrat, sans-serif",
      color: "#374151",
      textAlign: "center",
      fontWeight: 600,
    }}
  >
    Étape 1 — Télécharger le modèle
  </Typography>

  <ButtonAttribute
    type="button"
    Label="Télécharger le modèle Excel (.xlsx)"
    Bgcolor="#8b5cf6"
    color="white"
    bgColorHover="#7c3aed"
    height="48px"
    width="100%"
    endIcon={<FontAwesomeIcon icon={faDownload} color="white" style={{ fontSize: "14px" }} />}
    action={handleDownload}
    sx={{
      borderRadius: "8px",
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      transition: "all 0.2s ease",
      marginBottom: "20px",
      "&:hover": {
        boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
      },
    }}
  />

  <Divider sx={{ my: 3, borderColor: "#e5e7eb" }} />

  {/* Upload Section */}
  <Typography
    sx={{
      fontSize: "13px",
      mb: 2,
      fontFamily: "Montserrat, sans-serif",
      color: "#374151",
      textAlign: "center",
      fontWeight: 600,
    }}
  >
    Étape 2 — Importer votre fichier complété
  </Typography>

  <ButtonAttribute
    type="button"
    Label="Sélectionner et importer le fichier"
    Bgcolor="#8b5cf6"
    color="white"
    bgColorHover="#7c3aed"
    height="48px"
    width="100%"
    endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color="white" style={{ fontSize: "14px" }} />}
    action={triggerFileInput}
    sx={{
      borderRadius: "8px",
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      transition: "all 0.2s ease",
      marginBottom: "20px",
      "&:hover": {
        boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
      },
    }}
  />

  <input
    id="file-upload"
    type="file"
    accept=".xlsx, .xls"
    style={{ display: "none" }}
    onChange={handleFileImport}
  />

  {/* Progress */}
  <CustomizedProgressBars
    value={isLoading}
    color={
      isLoading === 100
        ? "success"
        : isLoading === 57
        ? "error"
        : "primary"
    }
  />
</Box>
                }
            />

            {/* Confirmation mot de passe */}
            <BasicModal
                open={openConfirmationPassword}
                onClose={handleCloseConfirmationPassword}
                ChildrenContent={
                    <Box>
                        <Box sx={{
                            backgroundColor: '#ef4444',
                            borderRadius: '6px',
                            padding: '20px',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="h4" sx={{
                                fontSize: { lg: '18px', md: '16px', sm: '14px', xs: '12px' },
                                fontFamily: 'Montserrat, sans-serif',
                                color: 'white',
                                fontWeight: 600,
                                letterSpacing: '-0.025em'
                            }}>
                                Confirmation de suppression
                            </Typography>
                        </Box>

                        <Typography variant="body1" sx={{
                            fontSize: { lg: '14px', md: '13px', sm: '12px', xs: '12px' },
                            mb: 3,
                            fontFamily: 'Montserrat, sans-serif',
                            color: '#374151',
                            textAlign: 'center',
                            fontWeight: 500
                        }}>
                            Saisissez votre mot de passe pour confirmer
                        </Typography>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <TextInputMui
                                type="password"
                                label="Mot de passe"
                                name="password"
                                value={ConfrimedPassword.password}
                                setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })}
                                required
                            />
                            <ButtonAttribute
                                type="submit"
                                Label="Confirmer la suppression"
                                Bgcolor="#ef4444"
                                color="white"
                                bgColorHover="#dc2626"
                                height="44px"
                                width="100%"
                                endIcon={<FontAwesomeIcon icon={faCheck} color="white" style={{ fontSize: '14px' }} />}
                                action={handleVerificationPassword}

                            />
                        </Box>
                    </Box>
                }
            />

            {/* Alerts */}
            <AlertBar open={alertOpen} onClose={() => setAlertOpen(false)} textContent="Carburant ajouté avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenSelectedModifier} onClose={() => setAlertOpenSelectedModifier(false)} textContent="Veuillez choisir une ligne" alertColor="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenNotModiferRow} onClose={() => setAlertOpenNotModiferRow(false)} textContent="Aucune information modifiée." alertColor="info" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
            <AlertBar open={alertOpenUpdatedCarburant} onClose={() => setAlertOpenUpdatedCarburant(false)} textContent="Carburant mis à jour avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenDeletedCarburant} onClose={() => setAlertOpenDeletedCarburant(false)} textContent="Carburant supprimée avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenPasswordNotValid} onClose={() => setAlertOpenPasswordNotValid(false)} textContent="Mot de passe incorrect." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenMultiDeletedCarburant} onClose={() => setAlertOpenMultiDeletedCarburant(false)} textContent="Carburants supprimées avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertOpenNotSelectedLineExtration} onClose={() => setAlertOpenNotSelectedLineExtration(false)} textContent="Sélectionnez des lignes pour exporter." alertColor="info" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
            <AlertBar open={alertOpenImport} onClose={() => setAlertOpenImport(false)} textContent="Importation effectuée avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
            <AlertBar open={alertErrorImport} onClose={() => setAlertErrorImport(false)} textContent="Importation non effectuée. Vérifiez votre fichier." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
            <AlertBar open={alertOpenConfirmDeleteCarburant} onClose={() => setAlertOpenConfirmDeleteCarburant(false)} textContent="Le mot de passe est incorrect." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </ThemeProvider>
    );
}
